import type { RootState } from 'js/src/libs/RootState';

export function selectDocumentId(state: RootState) {
    return state.document.document_id;
}

export function selectDocumentName(state: RootState) {
    return state.document.document_name;
}

export function selectDocumentUrl(state: RootState) {
    return state.document.document_url;
}

export function selectDocumentLanguageCode(state: RootState) {
    return state.document.document_language_code;
}
